import { deburr, lowerCase } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { Box, Icon, Tooltip } from '@mui/material'
import { actionIconStyle } from 'components/ActionUtil'

const Other = ({ tooltip, children, icon, onClick, ...otherProps }) => (
    <Box px={2} onClick={onClick} {...otherProps} >
        <Tooltip title={tooltip}>
            <Icon id={deburr(lowerCase(tooltip))} sx={{ ...actionIconStyle }}>{icon}</Icon>
        </Tooltip>
        { children || null }
    </Box>
)

Other.propTypes = {
    children: PropTypes.element,
    icon: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    onClick: PropTypes.func,
}

export default Other

